if (!customElements.get('manchot-endurance-gallery')) {
  class ManchotEnduranceGallery extends HTMLElement {
    connectedCallback() {
      this.removeTabListeners();
      this.tabs = Array.from(this.querySelectorAll('[data-endurance-tab]'));
      this.mediaPanels = Array.from(this.querySelectorAll('[data-endurance-media-panel]'));
      this.copyPanels = Array.from(this.querySelectorAll('[data-endurance-copy-panel]'));

      this.tabListeners = this.tabs.map((tab, index) => {
        const clickHandler = () => this.select(index);
        const keydownHandler = (event) => this.onKeydown(event, index);
        tab.addEventListener('click', clickHandler);
        tab.addEventListener('keydown', keydownHandler);
        return { tab, clickHandler, keydownHandler };
      });
    }

    disconnectedCallback() {
      this.removeTabListeners();
      this.querySelectorAll('video').forEach((video) => video.pause());
    }

    removeTabListeners() {
      this.tabListeners?.forEach(({ tab, clickHandler, keydownHandler }) => {
        tab.removeEventListener('click', clickHandler);
        tab.removeEventListener('keydown', keydownHandler);
      });
      this.tabListeners = [];
    }

    select(index, moveFocus = false) {
      if (!this.tabs[index]) return;

      this.tabs.forEach((tab, tabIndex) => {
        const selected = tabIndex === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
      });

      this.mediaPanels.forEach((panel, panelIndex) => {
        panel.hidden = panelIndex !== index;
        if (panelIndex !== index) {
          panel.querySelectorAll('video').forEach((video) => video.pause());
        }
      });

      this.copyPanels.forEach((panel, panelIndex) => {
        panel.hidden = panelIndex !== index;
      });

      if (moveFocus) this.tabs[index].focus();
    }

    onKeydown(event, index) {
      let nextIndex = null;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextIndex = (index + 1) % this.tabs.length;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = this.tabs.length - 1;
      }

      if (nextIndex === null) return;
      event.preventDefault();
      this.select(nextIndex, true);
    }
  }

  customElements.define('manchot-endurance-gallery', ManchotEnduranceGallery);
}

if (!customElements.get('manchot-endurance-sticky')) {
  class ManchotEnduranceSticky extends HTMLElement {
    connectedCallback() {
      this.teardown();
      this.hidden = true;
      this.classList.remove('is-visible');

      const section = this.closest('[product-info]');
      const formId = this.dataset.formId;
      this.primaryRegion = section?.querySelector(this.dataset.sourceSelector);
      this.primaryButton = document.getElementById(formId)?.querySelector('[name="add"]');
      this.stickyButton = this.querySelector('[data-endurance-sticky-submit]');

      if (!this.primaryRegion || !this.primaryButton || !this.stickyButton) return;

      this.hidden = false;
      this.syncButton();
      this.boundStickyClick = this.boundStickyClick || (() => this.primaryButton?.click());
      this.stickyButton.addEventListener('click', this.boundStickyClick);

      this.buttonObserver = new MutationObserver(() => this.syncButton());
      this.buttonObserver.observe(this.primaryButton, {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true,
      });

      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          this.classList.toggle('is-visible', !entry.isIntersecting);
        });
        this.visibilityObserver.observe(this.primaryRegion);
      }
    }

    disconnectedCallback() {
      this.teardown();
    }

    teardown() {
      if (this.stickyButton && this.boundStickyClick) {
        this.stickyButton.removeEventListener('click', this.boundStickyClick);
      }
      this.buttonObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.buttonObserver = null;
      this.visibilityObserver = null;
      this.primaryRegion = null;
      this.primaryButton = null;
      this.stickyButton = null;
    }

    syncButton() {
      const sourceText = this.primaryButton.querySelector('.btn--text')?.textContent.trim();
      this.stickyButton.disabled = this.primaryButton.disabled;
      if (sourceText) this.stickyButton.textContent = sourceText;
    }
  }

  customElements.define('manchot-endurance-sticky', ManchotEnduranceSticky);
}
